(() => {
  const pad = (n) => String(n).padStart(2, '0');
  const fmt = (s) => `${pad(Math.floor(s / 60))}:${pad(s % 60)}`;

  const init = (stage) => {
    if (stage.dataset.spotDemoReady === 'true') return;
    stage.dataset.spotDemoReady = 'true';

    const section = stage.closest('.spot-demo');
    const puck = stage.querySelector('[data-demo-puck]');
    const hint = stage.querySelector('[data-demo-hint]');
    const timers = section.querySelectorAll('[data-demo-timer]');
    const statusLabel = section.querySelector('[data-demo-status-label]');
    if (!section || !puck) return;

    let locked = false;
    let seconds = 0;
    let tick = null;

    const setHint = (text) => {
      if (!hint) return;
      hint.classList.add('is-swapping');
      window.setTimeout(() => {
        hint.textContent = text;
        hint.classList.remove('is-swapping');
      }, 200);
    };

    const render = () => timers.forEach((t) => { t.textContent = fmt(seconds); });

    const ping = () => {
      section.classList.remove('is-pinging');
      // Reflow erzwingen, damit die Animation neu startet
      void section.offsetWidth;
      section.classList.add('is-pinging');
      puck.classList.add('is-pressed');
      window.setTimeout(() => puck.classList.remove('is-pressed'), 180);
    };

    const lock = () => {
      locked = true;
      seconds = 0;
      render();
      section.classList.add('is-locked');
      puck.setAttribute('aria-pressed', 'true');
      if (statusLabel) statusLabel.textContent = stage.dataset.labelOffline || 'Offline';
      setHint(stage.dataset.hintAgain || '');
      tick = window.setInterval(() => { seconds += 1; render(); }, 1000);
    };

    const unlock = () => {
      locked = false;
      window.clearInterval(tick);
      section.classList.remove('is-locked');
      puck.setAttribute('aria-pressed', 'false');
      if (statusLabel) statusLabel.textContent = stage.dataset.labelOnline || 'Online';
      const done = (stage.dataset.hintDone || '').replace('{time}', fmt(seconds));
      setHint(done);
      window.setTimeout(() => {
        if (!locked) setHint(stage.dataset.hintTap || '');
      }, 2600);
    };

    spot.addEventListener('click', () => {
      ping();
      if (locked) unlock(); else lock();
    });
  };

  const boot = () => document.querySelectorAll('[data-spot-demo]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
